import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { articles } from '@/mocks/jinman';

export default function Articles() {
  return (
    <>
      <SchemaOrg type="WebPage" data={{ name: 'jinman - 文章资讯', description: '浏览jinman最新文章资讯，包括品牌故事、产品指南、行业洞察和用户故事。' }} />
      <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '文章资讯' }]} />

      <section className="bg-background-50 py-10 md:py-14" aria-labelledby="articles-heading">
        <div className="w-full px-4 md:px-6">
          <div className="text-center mb-10">
            <h1 id="articles-heading" className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              文章资讯
            </h1>
            <p className="text-sm text-foreground-600 max-w-xl mx-auto">
              了解 jinman 最新动态、产品指南与行业洞察
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {articles.map((article) => (
              <Link
                key={article.slug}
                to={`/articles/${article.slug}`}
                className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer no-underline block"
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs bg-accent-100 text-accent-700 px-2.5 py-0.5 rounded-full">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-500">{article.date}</span>
                  </div>
                  <h2 className="font-heading text-base text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h2>
                  <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                  <div className="mt-4 text-xs text-foreground-500">
                    {article.readTime} 阅读
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}